import React from "react";
import { CCol, CRow, CFormCheck } from "@coreui/react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

const validationSchema = Yup.object({
  full_name: Yup.string().required("Full Name is required"),
  address: Yup.string().required("Address is required"),
  gender: Yup.string().required("Gender is required"),
  dob: Yup.string().required("DOB is required"),
  phone: Yup.string().required("Phone Number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  ndis_number: Yup.string().required("NDIS Number is required"),
  participant_diagnosis: Yup.string().required(
    "Participant Diagnosis is required"
  ),
  support_level: Yup.array()
    .min(1, "Please select at least one level of support")
    .required("Support level is required"),
  plan: Yup.array()
    .min(1, "Please select at least one plan")
    .required("Plan is required"),
  start_date: Yup.string().required("Plan Start Date is required"),
  end_date: Yup.string().required("Plan End Date is required"),
  plan_manager_name: Yup.string().required("Plan Manager Name is required"),
  plan_manager_email: Yup.string()
    .email("Invalid email format")
    .required("Plan Manager Email is required"),
  participant_goal: Yup.string().required("Participant's Goal is required"),
  persons_disability_support_need: Yup.string().required(
    "Disability and Support Needs are required"
  ),
  plan2: Yup.array()
    .min(1, "Please select at least one from these plan")
    .required("Plan2 is required"),
 client_regular_medications: Yup.string().required("Please select if the client has regular medications"),
  medications_details: Yup.string().required("Medications Details is required"),
  requires_assistance_self_dress_groom: Yup.string().required(
    "Self-dress Grooming Assistance is required"
  ),
  requires_support_with_showering: Yup.string().required(
    "requires_support_with_showering Assistance is required"
  ),
  participant_is: Yup.string().required("Participant's status is required"),
  mobility: Yup.string().required("Mobility status is required"),
  hearing: Yup.string().required("Hearing status is required"),
  participant_vision: Yup.string().required("Vision status is required"),
  are__behaviours_concern: Yup.string().required(
    "Behaviours of Concern is required"
  ),
  referral_first_name: Yup.string().required("Referral First Name is required"),
  referral_last_name: Yup.string().required("Referral Last Name is required"),
  referral_phone: Yup.string().required("Referral Phone is required"),
  referral_email: Yup.string()
    .email("Invalid email format")
    .required("Referral Email is required"),
  referral_relationship_to_ndis_participant: Yup.string().required(
    "Referral Relationship is required"
  ),
  // ndis_plan_file: Yup.mixed()
  //   .required("NDIS Plan file is required")
  //   .test("fileSize", "File too large", (value) => {
  //     return value && value.size <= 5000000; // 5MB max size
  //   })
  //   .test("fileFormat", "Unsupported file format", (value) => {
  //     return (
  //       value && ["application/pdf", "image/png", "image/jpeg"].includes(value.type)
  //     );
  //   }),
});

export default function ReferrelsForm() {
  const handleSubmit = (values) => {
    // Show all form values in the console
    console.log("Form Values:", values);

    // Axios POST request to send form data
    axios
      .post("https://erp.rplconsultants.com.au/api/referrals", values)
      .then((response) => {
        alert("Form Submitted Successfully!");
      })
      .catch((error) => {
        console.error("Error submitting the form", error);
        alert("Error submitting the form.");
      });
  };

  return (
    <Formik
      initialValues={{
        full_name: "",
        address: "",
        gender: "",
        dob: "",
        phone: "",
        email: "",
        ndis_number: "",
        participant_diagnosis: "",
        support_level: [],
        plan: [],
        start_date: "",
        end_date: "",
        plan_manager_name: "",
        plan_manager_email: "",
        participant_goal: "",
        persons_disability_support_need: "",
        plan2: [],
        client_regular_medications: "",
        medications_details: "",
        requires_assistance_self_dress_groom: "",
        requires_support_with_showering: "",
        participant_is: "",
        mobility: "",
        hearing: "",
        participant_vision: "",
        are__behaviours_concern: "",
        referral_first_name: "",
        referral_last_name: "",
        referral_phone: "",
        referral_email: "",
        referral_relationship_to_ndis_participant: "",
        ndis_plan_file:null,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
       {({ setFieldValue }) => (
        <Form>
          <CRow>
            {/* Phase 1 */}
            <div className="mb-3">
              <h6 className="form-heading">Details of NDIS Participant</h6>
            </div>
            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>Full Name of Participant</label>
                <Field type="text" name="full_name" placeholder="Full Name" />
                <ErrorMessage
                  name="full_name"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>Address</label>
                <Field type="text" name="address" placeholder="Address" />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Gender</label>
                <Field as="select" name="gender">
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </Field>
                <ErrorMessage
                  name="gender"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Date of Birth</label>
                <Field type="date" name="dob" />
                <ErrorMessage
                  name="dob"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Phone Number</label>
                <Field type="text" name="phone" placeholder="Phone Number" />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Email</label>
                <Field type="text" name="email" placeholder="Email" />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            {/* Phase 1 -- End */}

            {/* Phase 2 */}
            <div className="mb-3 mt-5">
              <h6 className="form-heading">NDIS Details</h6>
            </div>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>NDIS Number</label>
                <Field
                  type="text"
                  name="ndis_number"
                  placeholder="NDIS Number"
                />
                <ErrorMessage
                  name="ndis_number"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Participant Diagnosis</label>
                <Field
                  type="text"
                  name="participant_diagnosis"
                  placeholder="Participant diagnosis"
                />
                <ErrorMessage
                  name="participant_diagnosis"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Level of Support</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <div>
                  <Field
                    type="checkbox"
                    name="support_level"
                    value="Level 1"
                    className="mb-2"
                    as={CFormCheck}
                  />
                  <label>Level 1</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    name="support_level"
                    value="High Intensity"
                    className="mb-2"
                    as={CFormCheck}
                  />
                  <label>High Intensity</label>
                </div>

                <ErrorMessage
                  name="support_level"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Plan</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <div>
                  <Field
                    type="checkbox"
                    name="plan"
                    value="Plan Managed"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Plan Managed</label>
                </div>
                <div>
                  <Field
                    type="checkbox"
                    name="plan"
                    value="Self Managed"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Self Managed</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    name="plan"
                    value="NDIA Managed"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>NDIA Managed</label>
                </div>

                <ErrorMessage
                  name="plan"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Plan Start Date</label>
                <Field type="date" name="start_date" />
                <ErrorMessage
                  name="start_date"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Plan End Date</label>
                <Field type="date" name="end_date" />
                <ErrorMessage
                  name="end_date"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Plan Manager Name (If Applicable)</label>
                <Field
                  type="text"
                  name="plan_manager_name"
                  placeholder="Plan Manager Name"
                />
                <ErrorMessage
                  name="plan_manager_name"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Email</label>
                <Field
                  type="text"
                  name="plan_manager_email"
                  placeholder="Plan Manager Email"
                />
                <ErrorMessage
                  name="plan_manager_email"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>Participant`s Goals</label>
                <Field
                  as="textarea"
                  name="participant_goal"
                  rows={5}
                  placeholder="Participant`s Goals"
                />
                <ErrorMessage
                  name="participant_goal"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>What is the persons disability and support needs?</label>
                <Field
                  as="textarea"
                  name="persons_disability_support_need"
                  rows={5}
                  placeholder="What is the persons disability and support needs?"
                />
                <ErrorMessage
                  name="persons_disability_support_need"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Plan</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <div>
                  <Field
                    type="checkbox"
                    id="cb6"
                    name="plan2"
                    value="Daily Living Activities"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Daily Living Activities</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    id="cb7"
                    name="plan2"
                    value="Social And Community Access"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Social And Community Access</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    id="cb8"
                    name="plan2"
                    value="Accommodation Services (SIL, MTA, STA)"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Accommodation Services (SIL, MTA, STA)</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    id="cb8"
                    name="plan2"
                    value="Household Task (Cleaning, Gardening, House Maintenance)"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>
                    Household Task (Cleaning, Gardening, House Maintenance)
                  </label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    id="cb9"
                    name="plan2"
                    value="Support Coordination"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Support Coordination</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    id="cb10"
                    name="plan2"
                    value="Community Nursing Care"
                    as={CFormCheck}
                    className="mb-2"
                  />
                  <label>Community Nursing Care</label>
                </div>

                <div>
                  <Field
                    type="checkbox"
                    id="cb11"
                    name="plan2"
                    value="Other"
                    as={CFormCheck}
                  />
                  <label>Other</label>
                </div>
              </div>
              <ErrorMessage
                name="plan2"
                component="div"
                className="error-message"
              />
            </CCol>
            <CCol lg={12} className="mb-3">
        <div className="form-input-wrapper">
          <label>File Upload (Upload NDIS Plan)</label>
          <input
            type="file"
            name="ndis_plan_file"
            
          />
         
        </div>
      </CCol>
      <CCol lg={12} className="mb-3">
        <div className="form-input-wrapper mb-3">
          <label>Does the client have regular medications?</label>
        </div>
        <div className="form-input-check d-flex flex-column">
          <Field
            type="radio"
            name="client_regular_medications"
            value="Yes"
            as={CFormCheck}
            
            label="Yes"
            className="mb-2"
          />
          <Field
            type="radio"
            name="client_regular_medications"
            value="No"
            as={CFormCheck}
            
            label="No"
            className="mb-2"
          />
          <ErrorMessage
            name="client_regular_medications"
            component="div"
            className="error-message"
          />
        </div>
      </CCol>
    

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <label>
                  If the answer was Yes, please provide details below
                </label>
                <Field
                  as="textarea"
                  name="medications_details"
                  rows={5}
                  placeholder="If the answer was Yes, please provide details below"
                />
                <ErrorMessage
                  name="medications_details"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Requires Assistance to self-dress and groom</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="requires_assistance_self_dress_groom"
                  value="Yes"
                  as={CFormCheck}
                  
                  label="Yes"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="requires_assistance_self_dress_groom"
                  value="No"
                  as={CFormCheck}
                  
                  label="No"
                  className="mb-2"
                />
                <ErrorMessage
                  name="requires_assistance_self_dress_groom"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Requires support with showering/bathing</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="requires_support_with_showering"
                  value="Yes"
                  as={CFormCheck}
                  
                  label="Yes"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="requires_support_with_showering"
                  value="No"
                  as={CFormCheck}
                  
                  label="No"
                  className="mb-2"
                />
                <ErrorMessage
                  name="requires_support_with_showering"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Participant is</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="participant_is"
                  value="Fully Verbal"
                  as={CFormCheck}
                  label="Fully Verbal"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="participant_is"
                  value="Non-Verbal"
                  as={CFormCheck}
                  label="Non-Verbal"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="participant_is"
                  value="Other"
                  as={CFormCheck}
                  label="Other"
                  className="mb-2"
                />
                <ErrorMessage
                  name="participant_is"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Mobility</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="mobility"
                  value="Independent"
                  as={CFormCheck}
                  id="cb21"
                  label="Independent"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="mobility"
                  value="Non-Ambulant"
                  as={CFormCheck}
                  id="cb22"
                  label="Non-Ambulant"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="mobility"
                  value="Requires some supervision"
                  as={CFormCheck}
                  id="cb23"
                  label="Requires some supervision"
                  className="mb-2"
                />
                <ErrorMessage
                  name="mobility"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Hearing</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="hearing"
                  value="No issues"
                  as={CFormCheck}
                  id="cb24"
                  label="No issues"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="hearing"
                  value="Hard of Hearing"
                  as={CFormCheck}
                  id="cb25"
                  label="Hard of Hearing"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="hearing"
                  value="Deaf"
                  as={CFormCheck}
                  id="cb26"
                  label="Deaf"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="hearing"
                  value="Use of Hearing Aids"
                  as={CFormCheck}
                  id="cb27"
                  label="Use of Hearing Aids"
                  className="mb-2"
                />
                <ErrorMessage
                  name="hearing"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Participant`s Vision</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="participant_vision"
                  value="No issues"
                  as={CFormCheck}
                  label="No issues"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="participant_vision"
                  value="Legally blind"
                  as={CFormCheck}
                  label="Legally blind"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="participant_vision"
                  value="Completely blind"
                  as={CFormCheck}
                  label="Completely blind"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="participant_vision"
                  value="Other"
                  as={CFormCheck}
                  label="Other"
                  className="mb-2"
                />
                <ErrorMessage
                  name="participant_vision"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper mb-3">
                <label>Are there behaviours of concern?</label>
              </div>
              <div className="form-input-check d-flex flex-column">
                <Field
                  type="radio"
                  name="are__behaviours_concern"
                  value="Yes"
                  as={CFormCheck}
                  label="Yes"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="are__behaviours_concern"
                  value="No"
                  as={CFormCheck}
                  label="No"
                  className="mb-2"
                />
                <Field
                  type="radio"
                  name="are__behaviours_concern"
                  value="Other"
                  as={CFormCheck}
                  label="Other"
                  className="mb-2"
                />
                <ErrorMessage
                  name="are__behaviours_concern"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <div className="mb-3 mt-5">
              <h6 className="form-heading">
                Details of Person Making Referral ( If same as above , please
                leave blank)
              </h6>
            </div>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Referral First Name</label>
                <Field
                  type="text"
                  name="referral_first_name"
                  placeholder="Referral First Name"
                />
                <ErrorMessage
                  name="referral_first_name"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Referral Last Name</label>
                <Field
                  type="text"
                  name="referral_last_name"
                  placeholder="Referral Last Name"
                />
                <ErrorMessage
                  name="referral_last_name"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Referral Phone</label>
                <Field
                  type="text"
                  name="referral_phone"
                  placeholder="Referral Phone"
                />
                <ErrorMessage
                  name="referral_phone"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Referral Email</label>
                <Field
                  type="text"
                  name="referral_email"
                  placeholder="Referral Email"
                />
                <ErrorMessage
                  name="referral_email"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Relationship to NDIS Participant</label>
                <Field
                  type="text"
                  name="referral_relationship_to_ndis_participant"
                  placeholder="Relationship to NDIS Participant"
                />
                <ErrorMessage
                  name="referral_relationship_to_ndis_participant"
                  component="div"
                  className="error-message"
                />
              </div>
            </CCol>
            <CCol lg={12} className="mt-4">
              <div className="form-submit">
                <button type="submit" className="theme-primary-btn">
                  Submit
                </button>
              </div>
            </CCol>
          </CRow>
        </Form>
      )}
    </Formik>
  );
}
